import { Link } from "react-router-dom";

export const SocialIcons = ({ link, children, classes, targetdata }) => {
  return (
    <Link
      className={`flex items-center justify-center sm:justify-end sm:gap-3 ${classes}`}
      to={link}
      target={targetdata}
    >
      {children}
    </Link>
  );
};
